import { createSelector } from '@ngrx/store';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter } from './item-type-classes.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(
    getManagementState,
    (state: ManagementState) => state.itemTypeClasses
);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);

export const ItemTypeClassesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getValidAll
};
